import React, { useState, useEffect, useMemo  } from "react";
import { useTranslation } from "react-i18next";
import { TabView, TabPanel } from 'primereact/tabview';
import { toast } from "react-toastify";
import PaymentOrderHistory from "./PaymentOrderHistory";
import { useAppContext } from "../../../AppContext";
import Loader from "../../Layout/Loader";
import Page404 from "../../Page404";
import PaymentOrderInfo from "./PaymentOrderInfo";
import PaymentOrderComments from "./PaymentOrderComments";
import PaymentBankAccounts from "./PaymentBankAccounts";
import "../open-banking.scss";
import { globalHandleChange } from "../../../services/functions";
import SummaryPaymentTable from "./PaymentOrderInvoiceSummary";
import PaymentOrderTotals from "./PaymentOrderTotals";
import { paymentOrderValid } from "./PaymentOrderUtils";
import { useGetPaymentOrderById, useSavePaymentOrder, useDuplicatePaymentOrder } from "./PaymentOrderService";
import { bankStatusStyle, generateStatusStyle } from "../../OpenBanking/OpenBankingUtils";
import { Link, useHistory } from 'react-router-dom';
import { faCopy, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DisabledLayover from "../../DisabledLayover";
import { bankStatus, openBankingStatus, compareStatus } from "../OpenBankingUtils";
import moment from "moment";
import MobileInvoiceWizard from "../../CustomInvoices/DemoWizardSteps/MobileInvoiceWizard";

const EditPaymentOrder = (props) => {
  const { t,i18n } = useTranslation("translations");
  const { user: [user], selectedCompany: [selectedCompany], company: [fullCompany] } = useAppContext();
  const [paymentOrderAttachments, setPaymentOrderAttachments] = useState([]);
  const paymentOrderId = props.match.params.id;
  const [reoladPage, setReloadPage] = useState(false);
  const [editBankAccountModal, setEditBankAccountModal] = useState({ show: false });

  const [validationErrors,setValidationErrors] = useState({})
  const history = useHistory()
  const {data:paymentOrder,setData:setPaymentOrder,loading:pageLoading,getPaymentOrder } = useGetPaymentOrderById(paymentOrderId)


  const valid = ({validateOnlyEmployeesFields=false,excludeFields,updatedPayroll}={})=>paymentOrderValid({validateOnlyEmployeesFields,t,setValidationErrors,data:paymentOrder,excludeFields})

  
  const { savePaymentOrderFn,loading:savingPaymentOrder }  = useSavePaymentOrder({valid,setEditBankAccountModal})
  const bankStatusObj = bankStatusStyle(paymentOrder?.bankStatus?.mappedStatusType?.id,t)

    const defaultPaymentOrder={
    paymentOrderRecords:[
      {
        docNumber:null,
        eInvoiceFic:null,
        dueDateTime:null,
        eInvoiceAmount:null,

      }
    ]
  }





  const handleChange = (e, selectKey, selectValue, length) =>
    globalHandleChange({
      key: (e?.target?.name ?? selectKey),
      value: (e?.target?.value ?? selectValue),
      setState: setPaymentOrder,
      length
    });

  const { duplicatePaymentOrder, loading:duplicateLoading } = useDuplicatePaymentOrder({
    id: paymentOrderId,
  });



  const savePaymentOrder= ({actionStatus})=>{
    const attachments = paymentOrderAttachments.map(({source,...restAtt})=>({...restAtt}))

    savePaymentOrderFn({paymentOrder:{...paymentOrder,attachments},actionStatus,onSuccess:(paymentOrder)=>{
      history.push("/edit-payment-order/" + paymentOrder.id);
      if(actionStatus?.action ==="delete"){ 
        history.push("/payment-order");
        return
      }
      setPaymentOrderAttachments([])
      getPaymentOrder()
  },onError:(err)=>{
      setPaymentOrderAttachments([])
      getPaymentOrder()
  }})
  }


  const createButton=(
      <Link to="/create-payment-order" className="btn btn-sm btn-info mb-2 mb-md-0">
        {t("navbar.create")}
      </Link>
  )

  const duplicateButton=(
    <button
      onClick={()=>duplicatePaymentOrder()}
      className={`btn btn-sm ${duplicateLoading || savingPaymentOrder ?"disabled":""} btn-outline-primary mr-2`}
      style={{minWidth:"max-content"}}

    >
      {duplicateLoading ? <FontAwesomeIcon className='mr-1' size='lg' icon={faSpinner} spin /> : <FontAwesomeIcon className="mr-1" icon={faCopy} />}
      {t("invoice.duplicate")}
    </button>
  )

  const refreshButton = (
    compareStatus(paymentOrder?.workflowStatus?.name, openBankingStatus.SENT_TO_BANK) && compareStatus(paymentOrder?.bankStatus?.mappedStatusType?.id, bankStatus.WAITING) &&
      <button
          className={`btn btn-sm btn-warning ml-2  mr-2 mb-md-0`}
          disabled={savingPaymentOrder || duplicateLoading}
          onClick={()=>savePaymentOrder({actionStatus:{action:"REFRESH_STATUS"}})}
          style={{minWidth:"max-content"}}
        >
          {savingPaymentOrder ? (
            <Loader size="xs" color="white" />
          ) : (
            t("openBanking.refreshButton")
          )}
      </button>
  )

  const dynamicActions = useMemo(()=>{
    return paymentOrder?.conditions?.actionStatusToList?.map(actionStatus=>{
      const { className="" } = actionStatus
      return (
              <button
          className={`${className} ml-2  mb-2 mb-md-0`}
          disabled={savingPaymentOrder || duplicateLoading}
          onClick={()=>savePaymentOrder({actionStatus})}
          style={{minWidth:"max-content"}}
        >
          {savingPaymentOrder ? (
            <Loader size="xs" color="white" />
          ) : (
            i18n.language=="alb"?actionStatus.albLabel:actionStatus.engLabel
          )}
      </button>
      )
    }) ?? []
  },[paymentOrder?.conditions,i18n.language,savingPaymentOrder,duplicateLoading,paymentOrder,paymentOrderAttachments,savePaymentOrderFn,savePaymentOrder])

  const refreshData = () => setReloadPage((state) => !state);

  const status = generateStatusStyle(paymentOrder?.workflowStatus?.name,t)

  const disabled = [2,3,5].includes(paymentOrder?.workflowStatus?.id)



  const infoSection = (
    <PaymentOrderInfo
      paymentOrder={paymentOrder}
      setPaymentOrder={setPaymentOrder}
      validationErrors={validationErrors}
      handleChange={handleChange}
      disabled={disabled}
      hasActions={true}
      isEdit={true}
    />
  );

  const bankAccountsSection = (
    <PaymentBankAccounts
      paymentOrder={paymentOrder}
      setPaymentOrder={setPaymentOrder}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      handleChange={handleChange}
      refreshData={refreshData}
      disabled={disabled}
      editBankAccountModal={editBankAccountModal}
      setEditBankAccountModal={setEditBankAccountModal}
    />
  );

  return !pageLoading ? (
    paymentOrder ? (
      <div className="demoInvoice open-banking mt-2">
        <div className="row">
          <div className="col-12">
            <div className="card p-xl-2">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center invoice-toolbar">
                <div className="d-flex align-items-center flex-wrap invoice-toolbar-checks">
                  <div className="d-flex justify-content-center align-items-center font-weight-bold">
                    {t("openBanking.profiscStatus")}:
                    <small className={`badge badge-${status.badgeClass} ml-2`} data-tooltip-id="global-tooltip" data-tooltip-content="ProFisc Status">
                      {status.status}
                    </small>
                  </div>
                  {bankStatusObj?.status && (
                    <div className="d-flex justify-content-center align-items-center ml-2 font-weight-bold">
                      {t("openBanking.bankStatus")}:
                      <small
                        className={`badge badge-${bankStatusObj.badgeClass} ml-2`}
                        data-tooltip-id="global-tooltip"
                        data-tooltip-content={
                          `Last Updated: ${paymentOrder?.bankStatus?.bankResponseDate ? moment(paymentOrder.bankStatus.bankResponseDate).format("DD/MM/YYYY HH:mm:ss") : "N/A"}${paymentOrder?.bankStatus?.bankError ? `\nMessage: ${paymentOrder.bankStatus.bankError}` : ""}`
                        }
                      >
                        {bankStatusObj.status}
                      </small>
                    </div>
                  )}
                </div>
                <div className="d-flex flex-wrap align-items-center gap-2 mt-2 mt-md-0 invoice-toolbar-actions">
                  <div className="actions d-flex flex-wrap gap-2">
                    {duplicateButton}
                    {refreshButton}
                    {createButton}
                    {dynamicActions}
                  </div>
                </div>
              </div>

              <div className="my-2 border-top border-success"></div>

              {/* Desktop: two columns */}
              <div className="row d-none d-md-flex">
                <div className="col-12 col-md-7 border-right" style={{height:"100% !important"}}>
                  {infoSection}
                </div>
                <div className="col-12 col-md-5" style={{height:"100% !important"}}>
                  {bankAccountsSection}
                </div>
              </div>

              {/* Mobile: wizard tabs */}
              <div className="d-md-none">
                <MobileInvoiceWizard errors={validationErrors} steps={[
                  {
                    label: t("paymentOrder.paymentOrderInfo"),
                    errorKeys: ["issueDateTime", "currency", "description"],
                    content: infoSection,
                  },
                  {
                    label: t("openBanking.bankAccounts"),
                    errorKeys: [/^buyerBankAccount/, /^sellerBankAccount/],
                    content: bankAccountsSection,
                  },
                ]} />
              </div>

              <div className="row">
                <div className="col-12 py-0" style={{minHeight:120,maxHeight:400}}>
                  <DisabledLayover disabled={!paymentOrder?.sellerBankAccountTransactional?.sellerNipt}>
                    <SummaryPaymentTable
                      defaultPaymentOrder={defaultPaymentOrder}
                      validationErrors={validationErrors}
                      setValidationErrors={setValidationErrors}
                      paymentOrder={paymentOrder}
                      setPaymentOrder={setPaymentOrder}
                      valid={valid}
                      disabled={disabled}
                    />
                  </DisabledLayover>
                </div>
              </div>
              <div className="row align-items-start">
                <div className="col-12 col-md-6 border-left" >
                  <TabView>
                    <TabPanel header={t("openBanking.attachmentsComments")}>
                      <PaymentOrderComments
                        paymentOrder={paymentOrder}
                        setPaymentOrder={setPaymentOrder}
                        handleChange={handleChange}
                        paymentOrderAttachments={paymentOrderAttachments}
                        setPaymentOrderAttachments={setPaymentOrderAttachments}
                        disabled={disabled}
                      />
                    </TabPanel>
                    <TabPanel header={t("openBanking.history")}>
                      <PaymentOrderHistory payment={paymentOrder} disabled={disabled} />
                    </TabPanel>
                  </TabView>
                </div>
                <div className="col-12 col-md-6 border-r">
                  <PaymentOrderTotals paymentOrder={paymentOrder} setPaymentOrder={setPaymentOrder}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <Page404 />
    )
  ) : (
    <Loader />
  );
};

export default EditPaymentOrder;
